import React, { useState } from "react";
import Navbar from "./Navbar";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import dev from "../assets/download.png";

const Welcome = ({ themeClass }) => {
  const [calcImageLoaded, setCalcImageLoaded] = useState(false);
  const [infoImageLoaded, setInfoImageLoaded] = useState(false);
  const [devImageLoaded, setDevImageLoaded] = useState(false);

  return (
    <div className={`${themeClass} min-h-screen w-screen overflow-y-auto overflow-x-hidden pb-10`}>
      <Navbar />
      <div className="text-center mt-[-10px] mb-8">
        <h3 className="text-xs md:text-sm text-gray-400 tracking-widest text-shadow">PROGRESS RUCOY ONLINE</h3>
      </div>
      
      <div className="flex w-full items-start justify-center flex-wrap gap-8 px-4">
        
        {/* Calculator Card */}
        <div className="rpg-panel flex flex-col items-center w-[400px]">
          <div className="bg-[#2563EB] w-full text-center py-2 mb-4 border-2 border-black box-shadow-inset">
            <h1 className="text-white font-bold text-sm">CALCULATORS</h1>
          </div>
          <Typography className="p-2 text-center text-xs mb-4 min-h-[50px] font-[VT323] text-lg text-gray-300">
            Exp, Power Train, Stat calculations and more tools to track your progress.
          </Typography>
          <div className="border-4 border-black mb-4 w-full h-[200px]">
            {!calcImageLoaded && (
              <div className="w-full h-full bg-gray-800 animate-pulse" />
            )}
            <img 
              src="https://www.rucoyonline.com/assets/screenshots/screenshot_1-4586706f374074855a8a1929bf7c9d78a0c0c6f6537e5afb9a5fac98150268c8.png" 
              className={`h-full w-full object-cover pixelated ${!calcImageLoaded && 'hidden'}`} 
              alt="calc"
              onLoad={() => setCalcImageLoaded(true)}
            />
          </div>
          <Link to={"/calculator"} className="w-full">
            <button className="rpg-btn primary w-full">OPEN TOOLS</button>
          </Link>
        </div>

        {/* Info Card */}
        <div className="rpg-panel flex flex-col items-center w-[400px]">
          <div className="bg-[#9333ea] w-full text-center py-2 mb-4 border-2 border-black box-shadow-inset">
            <h1 className="text-white font-bold text-sm">INFO & TIPS</h1>
          </div>
          <Typography className="p-2 text-center text-xs mb-4 min-h-[50px] font-[VT323] text-lg text-gray-300">
            Farming loops, Gold making strategies, and game mechanics.
          </Typography>
           <div className="border-4 border-black mb-4 w-full h-[200px]">
            {!infoImageLoaded && (
                <div className="w-full h-full bg-gray-800 animate-pulse" />
            )}
            <img 
              src="https://www.rucoyonline.com/assets/screenshots/screenshot_5-04890a6446ee657a7445b04e71b6c9eda101c3471a1690075471e1e18cfe7620.png" 
              className={`h-full w-full object-cover pixelated ${!infoImageLoaded && 'hidden'}`} 
              alt="info"
              onLoad={() => setInfoImageLoaded(true)}
            />
          </div>
          <Link to={"/info"} className="w-full">
            <button className="rpg-btn purple w-full">READ GUIDE</button>
          </Link>
        </div>

        {/* Dev Card */}
        <div className="rpg-panel flex flex-col items-center w-[400px]">
          <div className="bg-[#ca8a04] w-full text-center py-2 mb-4 border-2 border-black box-shadow-inset">
            <h1 className="text-black font-bold text-sm">CREDITS</h1>
          </div>
          <Typography className="p-2 text-center text-xs mb-4 min-h-[50px] font-[VT323] text-lg text-gray-300">
             The team behind Rucoy Helper.
             <br />
             	&nbsp;
          </Typography>
           <div className="border-4 border-black mb-4 w-full h-[200px] bg-black">
            {!devImageLoaded && (
                <div className="w-full h-full bg-gray-800 animate-pulse" />
            )}
            <img 
              src={dev} 
              className={`h-full w-full object-contain pixelated ${!devImageLoaded && 'hidden'}`} 
              alt="dev"
              onLoad={() => setDevImageLoaded(true)}
            />
          </div>
          <Link to={"/developers"} className="w-full">
            <button className="rpg-btn gold w-full">VIEW TEAM</button>
          </Link>
        </div>

      </div>
    </div>
  );
};

export default Welcome;